import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Heart } from "lucide-react";
import { DONATE_CONFIG } from "@/config/donate";

export const DonateNudge = ({ onOpen }) => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const donated = localStorage.getItem("has_donated") === "1";
    if (donated) { setVisible(false); return; }

    // If dismissed in the last 3 minutes, don't re-nudge (avoid being obnoxious per-nav)
    const dismissedAt = Number(localStorage.getItem("nudge_dismissed_at") || 0);
    if (dismissedAt && Date.now() - dismissedAt < 3 * 60 * 1000) return;

    const views = Number(localStorage.getItem("page_views") || 0) + 1;
    localStorage.setItem("page_views", String(views));

    if (views % Math.max(1, DONATE_CONFIG.nudgeEveryPageViews) === 0) {
      setVisible(false); // reset then show
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  const dismiss = () => {
    localStorage.setItem("nudge_dismissed_at", String(Date.now()));
    setVisible(false);
  };

  const permanent = () => {
    localStorage.setItem("nudge_dismissed_at", String(Date.now() + 24 * 60 * 60 * 1000));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="donate-nudge"
      className="fixed bottom-6 right-6 z-40 max-w-sm bg-[#0a0a0a] border border-[color:var(--accent-amber)]/50 p-4 reveal"
      style={{ boxShadow: "0 0 30px rgba(255,176,0,0.15)" }}
    >
      <button
        data-testid="donate-nudge-dismiss"
        onClick={dismiss}
        className="absolute top-2 right-2 text-neutral-500 hover:text-white p-1"
        style={{ transitionProperty: "color", transitionDuration: "150ms" }}
      >
        <X className="w-3 h-3" />
      </button>
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-amber)] mb-2">
        <Heart className="w-3 h-3" /> quick nudge
      </div>
      <div className="text-sm text-neutral-200 mb-3">
        Getting value from sAimonSays.Ai? Suggested donation is{" "}
        <span className="text-[color:var(--accent-amber)] font-bold">${DONATE_CONFIG.suggested}</span>. Anything helps.
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="donate-nudge-open"
          onClick={() => { setVisible(false); onOpen(); }}
          className="bg-[color:var(--accent-amber)] text-black px-3 py-1.5 text-[10px] uppercase tracking-widest font-bold hover:bg-white duration-150"
          style={{ transitionProperty: "background-color" }}
        >
          donate
        </button>
        <button
          data-testid="donate-nudge-later"
          onClick={dismiss}
          className="border border-white/15 text-neutral-400 px-3 py-1.5 text-[10px] uppercase tracking-widest hover:border-white/40 duration-150"
          style={{ transitionProperty: "border-color, color" }}
        >
          maybe later
        </button>
        <button
          data-testid="donate-nudge-mute"
          onClick={permanent}
          className="text-[9px] uppercase tracking-widest text-neutral-600 hover:text-neutral-400 duration-150 px-1"
          style={{ transitionProperty: "color" }}
        >
          mute 24h
        </button>
      </div>
    </div>
  );
};
